import config from "config/global";

export function getTagminSelfTapeUrl(selfTapeRequestId?: string) {
  const baseLoginUrl = `${config.tagmin.loginUrl}/#s=tapes`;

  return selfTapeRequestId
    ? `${baseLoginUrl}&req_id=${selfTapeRequestId}`
    : baseLoginUrl;
}
